import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { UserDataConsumer } from '../../utils';
import { Icon } from '../../components';
import Theme from '../../theme';
import { connect } from 'react-redux';
import { defaultScale } from '../../utils/scaling';
import { notificationsScreenOpened } from '../../ui';

export const NotificationBadge = (props) => {
  const unreadCount = props.user.notifications.manager.getUnreadNotificationCountSync();
  const gotToNotifications = () => {
    props.notificationsScreenOpened();
    props.navigation.navigate('Notifications', { id: '' })};
  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={{ marginRight: defaultScale(5) }}
        onPress={gotToNotifications}>
        <View>
          <Icon
            size={defaultScale(30)}
            color={Theme.GREY_DARK}
            name='ios-notifications-outline'
          />
          {unreadCount > 0 &&
            <View style={styles.badge}>
              <Text style={styles.badgeNumber}>
                {unreadCount}
              </Text>
            </View>
          }
        </View>
      </TouchableOpacity>
    </View>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    notificationsScreenOpened: () => dispatch(notificationsScreenOpened())
  };
}

export const UserNotificationBadge = UserDataConsumer(connect(null, mapDispatchToProps)(NotificationBadge));

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: defaultScale(15),
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  badge: {
    right: defaultScale(10),
    width: defaultScale(20),
    height: defaultScale(20),
    zIndex: 1000,
    borderRadius: 20 / 2,
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Theme.RED,
  },
  badgeNumber: {
    textAlign: 'center',
    color: Theme.WHITE,
  },
});
